import React from "react";
import LegalPageLayout from "../../organisms/LegalPageLayout";

const NOTICE_URL = "https://opensource.foursquare.com/places-notice-txt/";
const APACHE_LICENSE_URL = "https://www.apache.org/licenses/LICENSE-2.0";
const FOURSQUARE_OS_PLACES_URL = "https://opensource.foursquare.com/os-places/";

const LegalFoursquareOsPlacesPage = () => {
    return (
        <LegalPageLayout
            className="legal-foursquare-page"
            eyebrow="MUZONE Legal"
            title="Foursquare OS Places Attribution"
            titleId="foursquare-legal-title"
            lead={
                <>
                    Some venue and place data in MUZONE includes information from Foursquare OS Places.
                    Foursquare OS Places is made available under Apache-2.0 by Foursquare Labs, Inc.
                </>
            }
        >
            <section className="legal-page__section">
                <h2>Attribution</h2>
                <p>
                    MUZONE filters, normalizes, scores, verifies, and may modify Foursquare OS Places data
                    before publishing venue records. Foursquare is the source of the underlying OS Places data;
                    MUZONE is responsible for the Muzone-specific import policy, edits, publication decisions,
                    and user-facing presentation.
                </p>
                <p>
                    Review the official Foursquare OS Places NOTICE and the Apache-2.0 license before using or
                    redistributing data derived from Foursquare OS Places.
                </p>
                <ul>
                    <li>
                        <a href={NOTICE_URL} rel="noreferrer" target="_blank">
                            Official Foursquare OS Places NOTICE
                        </a>
                    </li>
                    <li>
                        <a href={APACHE_LICENSE_URL} rel="noreferrer" target="_blank">
                            Apache License 2.0
                        </a>
                    </li>
                    <li>
                        <a href={FOURSQUARE_OS_PLACES_URL} rel="noreferrer" target="_blank">
                            Foursquare OS Places project page
                        </a>
                    </li>
                </ul>
            </section>

            <section className="legal-page__section">
                <h2>Source Provenance</h2>
                <p>
                    MUZONE stores source provenance internally for Foursquare-derived venue rows so imported
                    records can be audited and refreshed without exposing Foursquare source identifiers in public
                    venue API payloads.
                </p>
                <pre className="legal-page__pre" aria-label="Foursquare source provenance fields">
{`{
  "source": "foursquare_os_places",
  "license": "Apache-2.0",
  "externalId": "venue_source_records.external_id",
  "dateRefreshed": "venue_source_records.source_refreshed_at",
  "modifiedByMuzone": true
}`}
                </pre>
            </section>

            <section className="legal-page__section">
                <h2>Contact</h2>
                <p>
                    For questions about MUZONE&apos;s use of Foursquare OS Places data, contact{" "}
                    <a href="mailto:muzone.me@gmail.com">muzone.me@gmail.com</a>.
                </p>
            </section>
        </LegalPageLayout>
    );
};

export default LegalFoursquareOsPlacesPage;
